import {Translation} from "./Translation";


export const en: Translation  = {

	point: "Point",
	cluster: "Cluster",
	geojson: "Polygon",
	theme: "Theme",
	light: "Light",
	dark: "Dark",
	system: "System",
	standard: "Standard",
	terrain: "Terrain",
	satellite: "Satellite",
	mapstyle: "Map Style",
	mapview: "Map View",
	legend: "Legend",
	hidelegend: "Hide legend",
	layer: "Layer",
	show: "Show",
	hide: "Hide",
	label: "Label",
	field: "Field",
	cancel: "Cancel",
	no: "No",
	yes: "Yes",
	confirm: "Confirm",
	dataset: "Dataset",
	datasetlayer: "Dataset/Layer",
	skip: "Skip",
	rename: "Rename",
	delete: "Delete",
	ok: "Ok",
	default: "Default",
	na: "N/A",

	importxofy: "Import ({{0}} of {{1}})",
	createnewdataset: "Create new dataset",
	createnewlayer: "Create new layer",
	searchsymbols: "Search symbols",
	addexistdataset: "Add to existing dataset",
	datasetexistsquestion: "It looks like this data type already exists in your map. You may create a new dataset, or append it to an existing dataset with the same data type.",
	add: "Add",
	addlayer: "Add Layer",
	layername: "Layer Name",
	layertype: "Layer Type",
	geofield: "Geo Field",
	geometry: "Geometry",
	country: "Country",
	state: "State",
	county: "County",
	tooltipfields: "Tooltip Fields",
	seladdtooltipfields: "Select additional tooltip fields",
	shape: "Shape",
	opacity: "Opacity",
	size: "Size",
	varysize: "Vary Size",
	nogeodatedetected: "No geographic data was detected in this list of symbols!",
	onlysomegeodataquestion: "Only some ({{0}} of {{1}}, or {{2}}%) of the symbols currently in this dataset contain geographic data. Are you sure you want to import this dataset?",
	deletedatasetx: "Delete dataset \"{{0}}\"?",
	deletelayerx: "Delete layer \"{{0}}\"?",

	fillcolors: "Fill Colors",
	usegradient: "Use Gradient",
	aligntodirection: "Align to Direction",
	renamedataset: "Rename Dataset",
	renamelayer: "Rename Layer",
	downloadingpoly: "Downloading polygons",
	polyerr: "Error downloading polygons!",
	dragtochangeorder: "Drag to change the order",
	addvalue: "Add value",
	defaultcolor: "Default color",
	clicktopintt: "Click point to pin the tooltip",
}